import { render } from "./Vendedores.vue?vue&type=template&id=041c19dc&scoped=true"
import script from "./Vendedores.vue?vue&type=script&lang=js"
export * from "./Vendedores.vue?vue&type=script&lang=js"

import "./Vendedores.vue?vue&type=style&index=0&id=041c19dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041c19dc"]])

export default __exports__